import { Component, OnInit, ViewChild } from '@angular/core';
import { TitlebarComponent } from '../../shared/titlebar/titlebar.component';
import { NotificationService, LoaderService, ErrorService } from "../../shared/session/index"
import { AccessService } from './Accesses/shared/access.service';
import { Iaccess } from './Accesses/shared/access.model';
import { SessionInfo } from 'src/app/shared/session/SessionInfo';
import { ModuleService } from './modules/shared/module.service';
import { HeaderComponent } from 'src/app/shared/header/header.component';

@Component({
  selector: 'app-landing',
  templateUrl: 'landing-access.component.html'
})
export class LandingAccessComponent implements OnInit {
  accesses: Iaccess;
  msgErrorGet: string;
  dataResult: any;
  @ViewChild(TitlebarComponent) titlebarComponent: TitlebarComponent;
  @ViewChild(HeaderComponent) headerComponent: HeaderComponent;

  constructor(private loaderService: LoaderService,
    private accessService: AccessService,
    private sessionInfo: SessionInfo,
    private errorService: ErrorService,
    private moduleService: ModuleService,
    private notificationService: NotificationService) { }

  ngOnInit() {
    this.titlebarComponent.msgTitle = [{ title: "Lista de Módulos del Usuario", event: "" }];
    let body = document.getElementsByTagName('body')[0];
    body.classList.add("bodyLanding");
    this.msgErrorGet = 'Error al listar accesos del usuario';
    this.headerComponent.listarMenuParametros();
    this.listarAccess(this.sessionInfo.getModuleID());
  }

  private listarAccess(moduleID: number): void {
    this.loaderService.show();
    this.accessService.listarPorAcceso(
      this.sessionInfo.getIdUsuario(), this.sessionInfo.getAplicacionID(), this.sessionInfo.getIdNivelAcceso(),
      this.sessionInfo.getIdEntidad(), this.sessionInfo.getRoleID(), moduleID)
      .subscribe(res => {
        this.accesses = res;
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  searchEmit(event: any) {
    this.listarAccess(event.moduleID)
  }
}
